// src/admin/components/BannerScheduleSection.jsx

import { useTheme } from "../../context/ThemeContext";

export default function BannerScheduleSection({
    formData,
    updateField,
}) {

    const { isDark } = useTheme();

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-2xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    return (

        <section
            className={`
                rounded-3xl
                border
                p-8
                space-y-6
                ${
                    isDark
                        ? "border-white/10 bg-white/5"
                        : "border-gray-200 bg-white"
                }
            `}
        >

            <div>

                <h2 className="text-xl font-semibold">
                    Schedule
                </h2>

                <p className="mt-1 text-sm opacity-70">
                    Control when this banner becomes visible and whether it is currently active.
                </p>

            </div>

            <div className="grid md:grid-cols-2 gap-6">

                <div>

                    <label className="block mb-2 font-medium">
                        Starts At
                    </label>

                    <input
                        type="datetime-local"
                        value={formData.starts_at || ""}
                        onChange={(e) =>
                            updateField(
                                "starts_at",
                                e.target.value
                            )
                        }
                        className={inputClass}
                    />

                </div>

                <div>

                    <label className="block mb-2 font-medium">
                        Ends At
                    </label>

                    <input
                        type="datetime-local"
                        value={formData.ends_at || ""}
                        onChange={(e) =>
                            updateField(
                                "ends_at",
                                e.target.value
                            )
                        }
                        className={inputClass}
                    />

                </div>

            </div>

            <label className="flex items-center gap-3">

                <input
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={(e) =>
                        updateField(
                            "is_active",
                            e.target.checked
                        )
                    }
                />

                <span className="font-medium">
                    Banner is Active
                </span>

            </label>

            <p className="text-sm opacity-70">
                Inactive banners are never displayed, regardless of their placement or schedule.
            </p>

        </section>

    );

}